import { AfterViewInit, ChangeDetectionStrategy, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { isNullOrUndefined } from '@sla-ng/core';
import { BehaviorSubject, distinctUntilChanged, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ICostUnitGroupOverview } from '../../../../models/cost-unit-group-overview.model';
import { ICostUnit } from '../../../../models/cost-unit.model';
import { ICostUnitGroupAssignmentsDialogLayout } from '../../../../models/layout/cost-unit-group-assignments-dialog-layout.model';
import { ICostUnitGroupState } from '../../../../services/facades/master-data/cost-unit-group-state.model';
import { CostUnitGroupFacade } from '../../../../services/facades/master-data/cost-unit-group.facade';
import { CostUnitGroupLayoutService } from '../../../../services/layout/cost-unit-group-layout.service';

@Component({
    templateUrl: './cost-unit-group-cost-unit-assignments.dialog.component.html',
    styleUrls: [ './cost-unit-group-cost-unit-assignments.dialog.component.scss' ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CostUnitGroupCostUnitAssignmentsDialogComponent implements OnInit, AfterViewInit {

    @ViewChild(MatSort)
    public sort!: MatSort;
    @ViewChild(MatPaginator)
    public paginator!: MatPaginator;

    public costUnitGroupState$: Observable<ICostUnitGroupState>;
    public formGroup$: BehaviorSubject<FormGroup> = new BehaviorSubject<FormGroup>(null);
    public costUnitSelected: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public dataSource: MatTableDataSource<ICostUnit> = new MatTableDataSource<ICostUnit>([]);
    public layout: ICostUnitGroupAssignmentsDialogLayout;

    constructor(
        private myMatDialogRef: MatDialogRef<CostUnitGroupCostUnitAssignmentsDialogComponent>,
        private myCostUnitGroupFacade: CostUnitGroupFacade,
        private myCostUnitGroupLayoutService: CostUnitGroupLayoutService,
        @Inject(MAT_DIALOG_DATA) public data: ICostUnitGroupOverview,
    ) {
    }

    public ngOnInit(): void {
        this.layout = this.myCostUnitGroupLayoutService.getCostUnitAssignmentsDialogLayout();
        this.costUnitGroupState$ = this.myCostUnitGroupFacade.subState();
        this.costUnitGroupState$.pipe(map((s: ICostUnitGroupState) => s.assignedCostUnits),
            distinctUntilChanged((prev, curr) => JSON.stringify(prev) === JSON.stringify(curr)))
            .subscribe((data: ICostUnit[]) => {
                this.dataSource.data = data;
            });
    }

    public ngAfterViewInit(): void {
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
    }

    public async assignCostUnit(): Promise<void> {
        const costUnits: number[] = this.formGroup$.value.getRawValue().selectedCostUnits;
        const assignedCostUnits = await this.myCostUnitGroupFacade.assignCostUnitToGroup(costUnits);
        this.formGroup$.value.controls[ 'selectedCostUnits' ].patchValue(assignedCostUnits.map(c => c.id));
    }

    public close(): void {
        this.myMatDialogRef.close(false);
    }

    public formGroupChange(formGroup: FormGroup): void {
        this.formGroup$.next(formGroup);

        formGroup.valueChanges.subscribe((value) => {
            if (isNullOrUndefined(value) || isNullOrUndefined(value.selectedCostUnits)) {
                this.costUnitSelected.next(false);
            } else {
                this.costUnitSelected.next(true);
            }
        });
    }
}
